<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />

      <!-- Store Selector for Super Admin (Desktop Only) -->
      <div v-if="isSuperAdmin" class="ml-3 d-none d-lg-block">
        <v-select
          v-model="selectedStore"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="storeOptions"
          label="name"
          :reduce="(option) => option.id"
          placeholder="選擇 Store"
          class="store-selector"
          @input="handleStoreChange"
        />
      </div>
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0" v-html="userName">
            </p>
            <p class="user-name font-weight-bolder mb-0" v-html="store_name"></p>
            <span class="user-status" v-html="storeName"></span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/19.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item link-class="d-flex align-items-center" @click="handleEditPassword">
          <feather-icon
            size="16"
            icon="EditIcon"
            class="mr-50"
          />
          <span>Edit Password</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center"  @click="handleLogout">
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

    <edit-password/>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import {getUserData} from '@/auth/utils'
import axiosIns from '@/libs/axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import EditPassword from './EditPassword.vue'
import vSelect from 'vue-select'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    vSelect,
    DarkToggler,
    EditPassword,
  },

  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      userName: getUserData().name,
      store_name: getUserData().store.name,
      storeName: '',
      storeId: '',
      isSuperAdmin: getUserData().is_admin === true || getUserData().is_admin === 1,
      storeOptions: [],
      selectedStore: getUserData().store_id,
    }
  },

  mounted() {
    if(!getUserData()) {
      this.$router.replace('/login')
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `Success`,
              icon: 'CoffeeIcon',
              variant: 'success',
              text: `You have successfully logged out!`,
            },
          })
        })
    }

    // 如果是 super admin，獲取所有 Store 列表
    if (this.isSuperAdmin) {
      this.fetchStoreOptions()
    }
  },

  methods: {
    handleEditPassword() {
      this.$root.$emit("bv::show::modal", "modal-edit-password", "#btnShow")
    },

    handleLogout() {
      // Request server to void the token
      axiosIns.get('/api/auth/logout')
      localStorage.clear()
      // Reqired to login page
      // Show the success message
      this.$router.replace('/login')
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `Success`,
              icon: 'CoffeeIcon',
              variant: 'success',
              text: `You have successfully logged out!`,
            },
          })
        })
    },

    // 獲取所有 Store 列表
    fetchStoreOptions() {
      axiosIns.get('/store/list', { params: { is_options: true } })
        .then(response => {
          this.storeOptions = response.data.stores
        })
        .catch(error => {
          console.error('Error fetching store options:', error)
        })
    },

    // 處理 Store 變更
    handleStoreChange(storeId) {
      if (storeId) {
        // 更新當前使用者的 store_id
        const userData = getUserData()
        userData.store_id = storeId

        // 獲取選中的 Store 資訊
        const selectedStore = this.storeOptions.find(store => store.id === storeId)
        if (selectedStore) {
          userData.store = selectedStore
          this.store_name = selectedStore.name
        }

        // 更新 localStorage 中的使用者資訊
        localStorage.setItem('userData', JSON.stringify(userData))

        // 顯示成功訊息
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: '成功',
            icon: 'CheckIcon',
            variant: 'success',
            text: `已切換到 ${selectedStore.name}`,
          },
        })

        // 重新整理頁面以獲取新 Store 的資料
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    },
  },
}
</script>

<style lang="scss">
.store-selector {
  min-width: 200px;
}

@import '@core/scss/vue/libs/vue-select.scss';
</style>
